import { Store } from "@betomorrow/micro-stores"
import { Periodicity } from "@modules/completedSessions/completedSessionsType"
import { Service } from "@modules/core/services/serviceType"
import { convertPublicProfileFromDto } from "@modules/profile/publicProfile/publicProfileDto"
import { PublicProfile } from "@modules/profile/publicProfile/publicProfileTypes"
import { PublicProfileApiGateway } from "@modules/profile/publicProfile/services/publicProfileApi.gateway"

export class PublicProfileService implements Service {
  publicProfileStore = new Store<PublicProfile>((id) => this.getProfile(id))

  constructor(private publicProfileApi: PublicProfileApiGateway) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async init(): Promise<void> {}

  async onLoggedOut(): Promise<void> {
    this.publicProfileStore.clear()
  }

  async getProfile(profileId: string) {
    const data = await this.publicProfileApi.getProfile(profileId)
    return convertPublicProfileFromDto(data)
  }

  fetchCompletedSessions = async ({
    id,
    periodicity,
    limit,
  }: {
    id: string
    periodicity: Periodicity
    limit: number
  }) => {
    const result = await this.publicProfileApi.getCompletedSessions(id, periodicity, limit)
    return result
  }
}
